function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import regeneratorRuntime from "regenerator-runtime";
import { useCallback, useEffect, useMemo, useReducer } from "react";
import { downloadDocumentFile, initDocumentBuilder, finalizeDocumentHtml, getDocumentFileInfo } from "../utils";
import { DocumentBuilderActionTypeEnum } from "../types";
var builderReducer = function(prevState, param) {
    var type = param.type, payload = param.payload;
    switch(type){
        case DocumentBuilderActionTypeEnum.INIT:
            return _objectSpreadProps(_objectSpread({}, prevState), {
                template: payload.template,
                html: payload.html,
                context: payload.context,
                isLoading: false
            });
        case DocumentBuilderActionTypeEnum.SET_STATE:
            return _objectSpread({}, prevState, payload);
        case DocumentBuilderActionTypeEnum.SET_HTML:
            return _objectSpreadProps(_objectSpread({}, prevState), {
                html: payload
            });
        case DocumentBuilderActionTypeEnum.SET_VIEW:
            return _objectSpreadProps(_objectSpread({}, prevState), {
                view: payload
            });
        case DocumentBuilderActionTypeEnum.SET_IS_LOADING:
            return _objectSpreadProps(_objectSpread({}, prevState), {
                isLoading: payload
            });
        case DocumentBuilderActionTypeEnum.SET_IS_SUBMITTING:
            return _objectSpreadProps(_objectSpread({}, prevState), {
                isSubmitting: payload
            });
        case DocumentBuilderActionTypeEnum.SET_ERROR:
            return _objectSpreadProps(_objectSpread({}, prevState), {
                error: payload.error,
                isError: payload.isError
            });
        default:
            throw new Error("Invalid action type");
    }
};
var useDocumentBuilderApi = function(config) {
    var ref = _slicedToArray(useReducer(builderReducer, {
        isLoading: true,
        isSubmitting: false,
        isError: false,
        error: null,
        html: "",
        template: "",
        context: {},
        view: "default"
    }), 2), state = ref[0], dispatch = ref[1];
    var save = config.save || downloadDocumentFile;
    var submit = useCallback(function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(options) {
            var _ref, fileName, rest;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch({
                            type: DocumentBuilderActionTypeEnum.SET_IS_SUBMITTING,
                            payload: true
                        });
                        if (!(state.isLoading || state.isSubmitting)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        _ctx.next = 5;
                        return finalizeDocumentHtml({
                            options: options,
                            context: state.context,
                            html: state.html,
                            config: config
                        });
                    case 5:
                        _ref = _ctx.sent;
                        fileName = _ref.fileName;
                        rest = _objectWithoutProperties(_ref, [
                            "fileName"
                        ]);
                        _ctx.next = 10;
                        return save(_objectSpreadProps(_objectSpread({}, rest), {
                            file: _objectSpread({
                                name: fileName
                            }, getDocumentFileInfo(options.type, config.docxParser) || {})
                        }), state);
                    case 10:
                        dispatch({
                            type: DocumentBuilderActionTypeEnum.SET_IS_SUBMITTING,
                            payload: false
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(options) {
            return _ref.apply(this, arguments);
        };
    }(), [
        config,
        save,
        state
    ]);
    var init = useCallback(_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var payload;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return initDocumentBuilder({
                        config: config,
                        onError: function(e) {
                            dispatch({
                                type: DocumentBuilderActionTypeEnum.SET_ERROR,
                                payload: {
                                    error: e,
                                    isError: true
                                }
                            });
                        }
                    });
                case 2:
                    payload = _ctx.sent;
                    dispatch({
                        type: DocumentBuilderActionTypeEnum.INIT,
                        payload: payload
                    });
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        config
    ]);
    // Initialize builder
    useEffect(function() {
        init();
    }, [
        init
    ]);
    var result = useMemo(function() {
        return _objectSpreadProps(_objectSpread({}, state), {
            config: config,
            submit: submit,
            updateState: dispatch,
            setHtml: function(payload) {
                dispatch({
                    type: DocumentBuilderActionTypeEnum.SET_HTML,
                    payload: payload
                });
            },
            setView: function(payload) {
                dispatch({
                    type: DocumentBuilderActionTypeEnum.SET_VIEW,
                    payload: payload
                });
            }
        });
    }, [
        submit,
        state,
        dispatch,
        config
    ]);
    return result;
};
export { useDocumentBuilderApi };
